// Mirrors IdentifierFieldUnit in the API (Belteq.bMark.Model/Enums/Enums.cs).
export enum IdentifierFieldUnit {
    Field = 1,
    Metric = 2,
}

// Mirrors the measure properties of UserProductionRowModel. Also used at runtime to resolve tag
// attribute keys onto row properties, so it must stay a value rather than becoming a type.
export const PRODUCTION_MEASURE_KEYS = [
    'productionMonths',
    'rateTotalOil',
    'cumulativeTotalOil',
    'waterRate',
    'waterCumulative',
    'liquidRate',
    'liquideCumulative',
    'totalGasRate',
    'totalGasCumulative',
    'gasInjectionRate',
    'waterInjectionRate',
    'wells',
    'producingGasOilRatio',
    'producingGasLiquidRatio',
    'producingWaterOilRatio',
    'producingOilGasRatio',
    'producingWaterCut',
    'offtakeRateOilPerEur',
    'offtakeRateLiquidPerEur',
    'offtakeRateGasPerEur',
    'offtakeRateOilPerCumulative',
    'offtakeRateGasPerCumulative',
    'eurProducedOil',
    'eurProducedGas',
    'recoveryFactorOilProduction',
    'recoveryFactorFreeGas',
] as const;

export type ProductionMeasureKey = typeof PRODUCTION_MEASURE_KEYS[number];

// Rows are sparse and the API serialises with DefaultIgnoreCondition = WhenWritingNull, so absent
// measurements are missing keys rather than nulls. Optional throughout is deliberate.
export type IUserProductionRow = { date?: string } & Partial<Record<ProductionMeasureKey, number>>;

// fieldName and country are read from the first stored row, so both are absent for an empty
// series. Take the field name from the summary or local dataset state instead.
export interface IUserProductionSeries {
    datasetId: string;
    identifierFieldId: string;
    fieldName?: string;
    country?: string;
    unit: IdentifierFieldUnit;
    rows: IUserProductionRow[];
}

export interface IUserProductionFieldSummary {
    identifierFieldId: string;
    fieldName?: string;
    rowCount: number;
    firstDate?: string;
    lastDate?: string;
}

// Fields with no production data are absent from the array, not present with rowCount 0.
export interface IUserProductionSummary {
    datasetId: string;
    unit: IdentifierFieldUnit;
    fields: IUserProductionFieldSummary[];
}
